const addressAdvices = {
  portage: {
    title: 'Distance de portage',
    summary: 'Il s\'agit de déterminer approximativement la distance à parcourir '
      + 'avec les meubles entre l\'entrée de votre logement et le camion de déménagement, '
      + 'en prenant en compte l\'intérieur du bâtiment et les espaces communs tels que les '
      + 'cours intérieures et les couloirs. '
      + '<br><br><u>Astuce</u> : comptez le nombre de pas depuis l\'entrée de votre logement jusqu\'à '
      + 'la zone de stationnement du camion, hors escaliers.',
  },
  vl: {
    title: 'Taille de camion',
    summary: 'Les dimensions moyennes d\'un camion poids lourd sont de 3,80 m de hauteur, '
      + '2,50 m de largeur et 10 m de longueur. Vérifiez bien si un camion de ces dimensions '
      + 'peut stationner à cet endroit. Dans le cas où il n\'est pas possible de stationner '
      + 'un poids lourd, les déménageurs viendront avec des camions de plus petite taille.',
  },
  mm_utilisable: {
    title: 'Monte-meubles',
    summary: 'Si vos meubles ne passent ni dans l\'ascenseur ni par les escaliers, '
      + 'l\'utilisation d\'un monte-meubles pourra être envisagée.',
    modalContent: '<p>Si vos meubles ne passent ni dans l\'ascenseur ni par les escaliers,'
      + 'l\'utilisation d\'un <b>monte-meubles</b> pourra être envisagée.</p>'
      + '<p>Pour savoir s\'il est possible d\'en utiliser un, vérifiez '
      + 'tout d\'abord si vos fenêtres sont suffisamment larges pour faire passer vos meubles.'
      + '<p>Vérifiez ensuite si vos fenêtres donnent sur la rue et s\'il y a assez de '
      + 'place en bas de votre immeuble pour positionner un petit véhicule.</p>'
      + '<p>Attachez une attention particulière à tout élément pouvant bloquer '
      + 'le passage par les fenêtres : présence d\'arbres, de lampadaire, '
      + 'd\'un arrêt de bus, d\'un restaurant avec terrasse, ou encore de travaux en cours. '
      + '<br>Dans le cas d\'un appartement côté cour, vérifiez si l\'accès à '
      + 'la cour intérieure est assez large pour faire entrer un petit véhicule.',
  },
  mm_obligatoire: {
    title: 'Monte-meubles',
    summary: 'Cette option peut s\'avérer plus coûteuse, mais vous permettra de '
      + 'limiter les risques d\'abîmer vos biens tout en préservant les parties communes.',
  },
  floor: {
    title: 'Etages',
    summary: 'Sélectionnez tous les niveaux dans lesquels il y a des biens à récupérer pour votre déménagement.<br>'
      + 'Par exemple, pour une maison avec 1 étage et une cave, sélectionnez RDC et 1, ainsi que -1 pour le sous-sol.',
  },
  all_in_lift: {
    title: 'Ascenseur',
    summary: 'Une fois tous vos meubles démontés, précisez s\'ils rentrent dans l\'ascenseur.',
  },
  stairs: {
    title: 'Escaliers',
    summary: 'Une fois tous vos meubles démontés, précisez s\'ils passent par les escaliers. '
     + 'Dans le cas contraire, l\'utilisation d\'un monte-meubles pourra être envisagée.',
  },
};
export default {
  address: addressAdvices,
  serviceOffer: {
    dates: {
      title: 'Dates',
      summary: 'Être flexible sur les dates de votre déménagement peut vous permettre de faire '
        + 'des économies car il sera plus facile d\'adapter votre demande aux '
        + 'plannings des déménageurs et bénéficier des créneaux les plus attractifs.',
    },
    cartons: {
      title: 'Cartons',
      summary: 'En choisissant cette prestation, le déménageur vous livrera '
        + 'vos cartons, une fois votre déménagement réservé.',
    },
    wardrobe: {
      title: 'Penderies',
      summary: 'Les cartons penderies sont parfaits pour le transport de vos vêtements sur cintres '
        + '(costumes, chemises, manteaux, robes, etc). Les déménageurs utilisent des penderies portables '
        + 'pour éviter de froisser vos vêtements.',
    },
    mount: {
      title: 'Démontage',
      summary: 'Seuls sont démontés les meubles dont le transport en l\'état peut présenter des difficultés : '
        + 'meubles lourds et/ou volumineux, passage impossible ou contraignant, '
        + 'éléments particulièrement fragiles, etc.',
      modalContent: 'Seuls sont démontés les meubles dont le transport en l\'état peut présenter des difficultés : '
        + 'meubles lourds et/ou volumineux, passage impossible ou contraignant, '
        + 'éléments particulièrement fragiles, etc. Cela peut également être envisagé '
        + 'en cas de besoin d\'optimisation de la place dans le camion. '
        + '<br><br>Le remontage ne concerne que les meubles ayant été démontés par les déménageurs. '
        + 'Les décrochages muraux ne sont pas inclus dans cette prestation.',
    },
    fragile: {
      title: 'Objets fragiles',
      summary: 'Un objet fragile est un objet qui risque de se casser pendant le déménagement. '
        + 'Cela peut être les objets composés de verre, de céramique, de porcelaine (vaisselle, bibelots, cadres, '
        + 'lampes, bouteilles d\'alcool, etc.).',
      modalContent: 'Un objet fragile est un objet qui risque de se casser pendant le déménagement. '
        + 'Cela peut être les objets composés de verre, de céramique, de porcelaine (vaisselle, bibelots, cadres, '
        + 'lampes, bouteilles d\'alcool, etc.).'
        + '<br><br>Sachez que si vous vous chargez vous-même de l\'emballage des objets fragiles, '
        + 'les déménageurs pourront ne pas être tenus responsables d\'une casse due à un défaut d\'emballage.',
    },
    unbreakable: {
      title: 'Objets non fragiles',
      summary: 'Les objets non-fragiles sont ceux qui ne nécessitent pas de protection particulière '
        + 'pour être transportés (vêtements, livres, jouets, couverts, casseroles, etc.).',
    },
  },
  boxes: {
    title: 'Types de cartons',
    summary: 'A cette étape, estimez le nombre de cartons à déménager.'
      + '<br>Il existe différents types de cartons selon les besoins.',
    modalContent: '<p>A cette étape, estimez le nombre de cartons à déménager.</p>'
      + '<p>Il existe différents types de cartons selon les besoins.</p><ul>'
      + '<li><b>Cartons standards</b> (L 55 x l 35 x H 30 cm) : utilisés pour tout type d\'objets.</li>'
      + '<li><b>Cartons livres</b> (L 35 x l 30 x H 30 cm) : plus petits, '
      + 'les cartons livres sont utilisés pour tous les objets lourds, comme les livres mais '
      + 'aussi la vaisselle par exemple, afin de ne pas surcharger un carton standard.</li>'
      + '<li><b>Cartons penderies</b> (L 50 x l 50 x H 100 cm) : spécifiques aux vêtements sur cintres.</li></ul>',
  },
  deliveryBoxes: {
    title: 'Cartons à fournir',
    summary: 'Peut-être avez-vous déjà des cartons. '
      + 'Dites-nous ici combien de cartons vous souhaitez que les déménageurs vous fournissent.',
  },
  insurance: {
    title: 'Assurance',
    summary: 'Toutes les offres que nous proposons incluent une assurance classique, '
      + 'dite &laquo; contractuelle &raquo;, indexée sur la valeur déclarée des '
      + 'biens transportés par les déménageurs.',
    modalContent: '<p>Toutes les offres que nous proposons incluent une assurance classique, '
      + 'dite &laquo; contractuelle &raquo;, indexée sur la valeur déclarée des '
      + 'biens transportés par les déménageurs.</p>'
      + '<p>L\'assurance classique corespond à une garantie minimum obligatoire '
      + 'qui couvre les obligations contractuelles du déménageur et prend en charge '
      + 'les évènements qui sont du fait du déménageur, à l\'exclusion de tout autre '
      + 'risque comme la faute du client (un objet mal emballé qui se casse pendant '
      + 'le déménagement), une force majeure (accident routier, camion volé, etc.), '
      + 'un vice propre au bien (meuble qui ne supporte pas le transport).</p>',
  },
  insuranceComp: {
    title: 'Assurance complémentaire',
    summary: 'L\'assurance complémentaire dite &laquo; dommages &raquo; '
      + 'couvre l\'intégralité des dommages subis sur votre mobilier pendant '
      + 'toute la durée du déménagement, même si la responsabilité du déménageur '
      + 'n\'est pas engagée (exemple : camion volé).<br>'
      + 'A titre indicatif, le coût de cette assurance s\'élève '
      + 'entre 0,5% et 0,7% de la valeur déclarée.',
  },
  inventory: {
    title: 'Inventaire',
    summary: 'Ajoutez vos meubles et objets dans chacune de vos pièces.'
      + '<br><br>Être exhaustif dans votre inventaire vous permettra '
      + 'de recevoir des devis fermes et définitifs !',
  },
  fixedAdvices: {
    serviceOfferServices: {
      title: 'Prestations incluses',
      content: 'Toutes nos prestations incluent le chargement, '
        + 'le transport et la remise en place de vos biens, '
        + 'ainsi que la protection des meubles et des électroménagers.',
    },
    serviceOfferAssurance: {
      title: 'Assurance',
      content: 'Nextories s\'assure systématiquement de la validité '
        + 'des contrats d\'assurance de ses partenaires déménageurs.',
    },
  },
};
